/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Pressureswitchdefect2Inputs */



/**
* | output |
* | --- |
* | "Pressure switch fault" |
*
* @param {Ahu_History_Key_Pressureswitchdefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_pressureswitchdefect2 = /** @type {((inputs?: Ahu_History_Key_Pressureswitchdefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Pressureswitchdefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pressure switch fault")
	return /** @type {LocalizedString} */ ("Défaut pressostat")
});
export { ahu_history_key_pressureswitchdefect2 as "ahu_history_key_pressureSwitchDefect" }